import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment';
import { getDrafts } from '../../../../core/actions/courseGet';
import { Table, Icon, Button, Tag, Row, Popconfirm, notification, Input } from 'antd';
import { Link } from 'react-router-dom'
import Highlighter from 'react-highlight-words';


const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};

export class CourseManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      courses: [],
      filteredInfo: null,
      searchText: '',
    }

    this.restructurePosts = this.restructurePosts.bind(this)
  }

  componentDidMount() {
    // console.log(this.state)
    const { courses } = this.state;
    if (!courses.length) {
      this.props.getDrafts(true);
      // console.warn(posts)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { courses } = nextProps;
    if (courses.length > 0) {
      // this.setState({ users })
      this.restructurePosts(courses)
    }
  }

  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', filters);
    this.setState({
      filteredInfo: filters
    });
  };



  restructurePosts(courses) {
    let newCourses = []
    courses.forEach(element => {
      newCourses.push(Object.assign(element, { key: element.id }))
    });
    this.setState({
      courses: newCourses
    }, () => {
      console.log(this.state.courses)
    })
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const { courses } = this.state 
    let { filteredInfo } = this.state 
    filteredInfo = filteredInfo || {};   
    const columns = [
      // {
      //   title: 'USER ID',
      //   dataIndex: 'id',
      //   key: 'id'
      // },
      {
        title: 'TITLE',
        dataIndex: 'title',
        key: 'title',
        width: 150,
        ...this.getColumnSearchProps('title')
      },
      // {
      //   title: 'SLUG',
      //   dataIndex: 'slug',
      //   key: 'slug',
      //   render: (text, record) => (
      //     <span>
      //       <Tag color="blue" className="tag">{record.slug} </Tag>
      //     </span>
      //   )
      // }, 
      {
        title: 'USERNAME',
        dataIndex: 'userName',
        key: 'userName',
        width: 150
      },
      {
        title: 'DATE CREATED',
        dataIndex: 'created',
        key: 'created',
        // fixed: 'right',
        render: (text, record) => (
          <span className="">
            {moment(record.created).format("MMMM Do YYYY")}
          </span>
        )
      },
      {
        title: 'ACTION',
        key: 'action',
        render: (text, record) => (
          <span>
            <Button type="primary" className="edit-btn" size="small"><Link to={`/editCourse/${record.slug}`}> Edit <Icon type="edit" /></Link></Button>
          </span>
        )
      }
    ]

    return (
      <div className="course-mgt">
        <Row>
          <Table dataSource={courses} columns={columns} scroll={{ y: 400 }} onChange={this.handleChange}
          />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.getCourses.drafts
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getDrafts
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CourseManagement)
